import { r as registerInstance, h } from './index-e3eeb4ec.js';
import { L as Locale } from './index-6afae4e4.js';
const indexCss$1 = ".phx-skip-back-btn>svg,.phx-skip-forward-btn>svg{width:25px}.phx-skip-back-btn:hover path,.phx-skip-forward-btn:hover path{fill:#747474}.phx-skip-back-btn:hover path:first-child,.phx-skip-forward-btn:hover path:first-child{fill:transparent;stroke:#747474}";
const SkipBackBtnStyle0 = indexCss$1;
const SkipBackBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.skipNumberOfSecs = seconds => {
      const updatedCurrentTime = this.publicAPI.media.getCurrentTime() + seconds;
      this.publicAPI.media.setCurrentTime(updatedCurrentTime);
    };
  }
  handleClick() {
    this.skipNumberOfSecs(-15);
  }
  render() {
    var _a;
    const mediaItem = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData;
    if (mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.isLive) return null;
    return h("button", {
      type: "button",
      class: "phx-skip-back-btn"
    }, h("svg", {
      class: "skipback-svg",
      viewBox: "0 0 27 32"
    }, h("path", {
      fill: "none",
      "stroke-width": "2.5",
      stroke: "#000000",
      d: "m 1.2785503,17.300016 c 0,6.658278 5.3244743,12.072957 11.9478267,12.218438 0.09095,0.002 0.18216,0.003 0.273596,0.003 0.06556,0 0.131019,-5.15e-4 0.196343,-0.0015 6.582166,-0.103648 11.900831,-5.410861 12.022934,-11.988545 0.0014,-0.07694 0.0022,-0.154047 0.0022,-0.231325 0,-0.09968 -0.0012,-0.199103 -0.0036,-0.298224 C 25.644088,13.92122 24.430426,11.122979 22.482499,9.0126992 20.249536,6.5936251 17.051701,5.07858 13.500007,5.07858"
    }), h("path", {
      fill: "#000000",
      d: "M 13.547417,0 V 10.241378 L 5.123,5.120689 Z"
    }), h("path", {
      fill: "#000000",
      d: "M 11.098438,21.279159 H 9.433567 v -4.55819 l 0.01616,-0.748922 0.02694,-0.818966 -0.309091,0.303155 C 9.050874,15.567659 8.961735,15.648001 8.900158,15.697263 L 7.9949864,16.424633 7.1921845,15.422478 9.7299,13.402004 h 1.368534 z m 5.048492,-5.032328 c 0.761498,0 1.367634,0.21372 1.818426,0.641164 0.450793,0.427445 0.676186,1.012928 0.676186,1.756466 0,0.880033 -0.27119,1.557109 -0.813578,2.03125 -0.542388,0.47414 -1.318242,0.711207 -2.327586,0.711207 -0.876441,0 -1.584049,-0.141881 -2.122845,-0.425647 v -1.438577 c 0.283766,0.150862 0.614222,0.273886 0.991379,0.369073 0.377157,0.09519 0.734553,0.14278 1.072199,0.14278 1.016528,0 1.524784,-0.416663 1.524784,-1.25 0,-0.793826 -0.526216,-1.190733 -1.578664,-1.190733 -0.190374,0 -0.400501,0.01886 -0.630387,0.05657 -0.229887,0.03771 -0.416666,0.07812 -0.560345,0.121228 L 13.533783,17.416009 13.830119,13.402 h 4.27263 v 1.411638 h -2.8125 l -0.145475,1.546336 0.188578,-0.03771 c 0.21911,-0.05029 0.4903,-0.07543 0.813578,-0.07543 z"
    })), h("label", {
      class: "phx-tooltip"
    }, this.locale.skipBack));
  }
};
SkipBackBtn.style = SkipBackBtnStyle0;
const indexCss = ".phx-skip-back-btn>svg,.phx-skip-forward-btn>svg{width:25px}.phx-skip-back-btn:hover path,.phx-skip-forward-btn:hover path{fill:#747474}.phx-skip-back-btn:hover path:first-child,.phx-skip-forward-btn:hover path:first-child{fill:transparent;stroke:#747474}";
const SkipForwardBtnStyle0 = indexCss;
const SkipForwardBtn = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.locale = Locale();
    this.skipNumberOfSecs = seconds => {
      const updatedCurrentTime = this.publicAPI.media.getCurrentTime() + seconds;
      this.publicAPI.media.setCurrentTime(updatedCurrentTime);
    };
  }
  handleClick() {
    this.skipNumberOfSecs(+15);
  }
  render() {
    var _a;
    const mediaItem = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData;
    if (mediaItem === null || mediaItem === void 0 ? void 0 : mediaItem.isLive) return null;
    return h("button", {
      type: "button",
      class: "phx-skip-forward-btn"
    }, h("svg", {
      class: "skipforward-svg",
      viewBox: "0 0 27 32"
    }, h("path", {
      fill: "none",
      "stroke-width": "2.5",
      stroke: "#000000",
      d: "m 25.72145,17.300016 c 0,6.658278 -5.324474,12.072957 -11.947827,12.218438 -0.09095,0.002 -0.18216,0.003 -0.273596,0.003 -0.06556,0 -0.131019,-5.15e-4 -0.196343,-0.0015 C 6.7215183,29.416306 1.4028533,24.109093 1.2807503,17.531409 c -0.0014,-0.07694 -0.0022,-0.154047 -0.0022,-0.231325 0,-0.09968 0.0012,-0.199103 0.0036,-0.298224 0.073762,-3.08064 1.287424,-5.878881 3.235351,-7.9891608 C 6.7504643,6.5936251 9.9482993,5.07858 13.499993,5.07858"
    }), h("path", {
      fill: "#000000",
      d: "M 13.423,0 V 10.241378 L 21.847417,5.120689 Z"
    }), h("path", {
      fill: "#000000",
      d: "M 11.098438,21.279159 H 9.433567 v -4.55819 l 0.01616,-0.748922 0.02694,-0.818966 -0.309091,0.303155 C 9.050874,15.567659 8.961735,15.648001 8.900158,15.697263 L 7.9949864,16.424633 7.1921845,15.422478 9.7299,13.402004 h 1.368534 z m 5.048492,-5.032328 c 0.761498,0 1.367634,0.21372 1.818426,0.641164 0.450793,0.427445 0.676186,1.012928 0.676186,1.756466 0,0.880033 -0.27119,1.557109 -0.813578,2.03125 -0.542388,0.47414 -1.318242,0.711207 -2.327586,0.711207 -0.876441,0 -1.584049,-0.141881 -2.122845,-0.425647 v -1.438577 c 0.283766,0.150862 0.614222,0.273886 0.991379,0.369073 0.377157,0.09519 0.734553,0.14278 1.072199,0.14278 1.016528,0 1.524784,-0.416663 1.524784,-1.25 0,-0.793826 -0.526216,-1.190733 -1.578664,-1.190733 -0.190374,0 -0.400501,0.01886 -0.630387,0.05657 -0.229887,0.03771 -0.416666,0.07812 -0.560345,0.121228 L 13.533783,17.416009 13.830119,13.402 h 4.27263 v 1.411638 h -2.8125 l -0.145475,1.546336 0.188578,-0.03771 c 0.21911,-0.05029 0.4903,-0.07543 0.813578,-0.07543 z"
    })), h("label", {
      class: "phx-tooltip"
    }, this.locale.skipForward));
  }
};
SkipForwardBtn.style = SkipForwardBtnStyle0;
export { SkipBackBtn as skip_back_btn, SkipForwardBtn as skip_forward_btn };